import { RouteObject } from 'react-router'
import { publicInvitationRoutes } from '$features/invitations/routes/public'
import { publicAuthRoutes } from '$features/auth/routes/public'
import { publicOnboardingRoutes } from '$features/onboarding/routes/public'
import { publicAppointmentRoutes } from '$features/appointments/routes/public'

export const publicRoutes: RouteObject[] = [
  ...publicAuthRoutes,
  ...publicInvitationRoutes,
  ...publicOnboardingRoutes,
  ...publicAppointmentRoutes,
]
